<div class="settings-page">
    <div class="settings-page__content">
        <div class="settings-card">
            <div class="settings-card__header">
                <img src="/assets/images/Group 24.svg" alt="" />
                <div class="settings-card__header-headline">
                    <h2>Bine ați venit</h2>
                    <h4>Instituții - Setări - Portal Operator {{env.config.appName}} </h4>
                </div>
            </div>
        </div>
    </div>

    <div class="content-box">
        <div class="settings-page-container">
            <mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
                <mat-button-toggle [value]="option" class="settings-page_menu-item"
                    *ngFor="let option of filteredComponents">
                    {{ option }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="settings-page__content">
            <ng-container *ngIf="selectedComponent === InstitutiiSettingsSidebar.ANI">
                <app-ani></app-ani>
            </ng-container>
            <ng-container *ngIf="selectedComponent === InstitutiiSettingsSidebar.CATEGORII_DOCUMENTE">
                <app-categorii-documente></app-categorii-documente>
            </ng-container>
            <ng-container *ngIf="selectedComponent === InstitutiiSettingsSidebar.TIPURI_DOCUMENTE">
                <app-tipuri-documente></app-tipuri-documente>
            </ng-container>
            <ng-container *ngIf="selectedComponent === InstitutiiSettingsSidebar.SECTIUNI_PUBLICE">
                <app-sectiuni-publice></app-sectiuni-publice>
            </ng-container>

            <div class="row" *ngIf="selectedComponent == null">
                <div class="col-sm-12 py-5">
                    <div class="row h-100 justify-content-center align-items-center">
                        <div class="col-12 text-center">
                            <div class="py-3">
                                <p class="mb-0">Selectați o secțiune</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <ng-container *ngIf="selectedComponent === AdminSettingsSidebar.PERMISSION_ACTION">
                <app-permissions-action-admin></app-permissions-action-admin>
            </ng-container>
            <ng-container *ngIf="selectedComponent === AdminSettingsSidebar.SECTIONS">
                <app-sectiuni></app-sectiuni>
            </ng-container>
            <ng-container *ngIf="selectedComponent === AdminSettingsSidebar.PERMISSION">
                <app-permisiuni></app-permisiuni>
            </ng-container> -->
        </div>
    </div>
</div>